import * as React from 'react';
import { Col, Nav, NavItem, NavLink, Row } from 'reactstrap';
import { Workflows } from './Workflows';
import * as matchSorter from 'match-sorter';
import classnames from 'classnames';

const pagesStyles = require('../pages.css');

const fuzzyTextFilterFn = (rows, id, filterValue) => {
  return matchSorter(rows, filterValue, { keys: [(row) => row.values[id]] });
};

// Let the table remove the filter if the string is empty
fuzzyTextFilterFn.autoRemove = (val) => !val;
export const fuzzyTextFilterFnExp = fuzzyTextFilterFn;

export const WorkflowsContainer = () => {
  // Tab 0 = Active (default landing tab per product spec; "All Workflows" tab removed)
  const [activeTab, setActiveTab] = React.useState(0);

  return (
    <div className={`${pagesStyles.container} ${pagesStyles.fullHeight}`}>
      <Row className={pagesStyles.headerRow}>
        <Col sm={{ size: 12 }} className={pagesStyles.noPadding}>
          <h3>Workflows</h3>
        </Col>
      </Row>
      <Nav tabs>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === 0 })}
            onClick={() => setActiveTab(0)}
          >
            Active Workflows
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === 1 })}
            onClick={() => setActiveTab(1)}
          >
            Errored Workflows
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === 2 })}
            onClick={() => setActiveTab(2)}
          >
            Archived Workflows
          </NavLink>
        </NavItem>
      </Nav>

      {/* Each tab mounts its own Workflows instance with mutually exclusive RTDB filters */}
      <div hidden={activeTab !== 0} className={pagesStyles.fullHeight}>
        <Workflows archived={false} />
      </div>
      <div hidden={activeTab !== 1} className={pagesStyles.fullHeight}>
        <Workflows errored={true} archived={false} />
      </div>
      <div hidden={activeTab !== 2} className={pagesStyles.fullHeight}>
        <Workflows archived={true} />
      </div>
    </div>
  );
};
